'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogRemote = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogRemote = exports.CatalogRemote = {
    fetchCatalogsByIds: function fetchCatalogsByIds(_ref) {
        var authToken = _ref.authToken,
            catalogIds = _ref.catalogIds,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/small/catalogs' });
            request.send({ ids: catalogIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchCuratorsForCatalog: function fetchCuratorsForCatalog(_ref2) {
        var catalogId = _ref2.catalogId,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ deployment: deployment, path: '<ITEM-API>catalog/' + catalogId + '/curators' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchRegisteredCatalogs: function fetchRegisteredCatalogs(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>catalog/registration' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchUpcomingCatalogs: function fetchUpcomingCatalogs(_ref4) {
        var authToken = _ref4.authToken,
            deployment = _ref4.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/small/upcomingcatalogs' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postCatalogItems: function postCatalogItems(_ref5) {
        var authToken = _ref5.authToken,
            catalogIds = _ref5.catalogIds,
            count = _ref5.count,
            deployment = _ref5.deployment,
            cursor = _ref5.cursor,
            itemId = _ref5.itemId,
            page = _ref5.page;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/small/catalog/items' });
            var data = {};
            if (global.__SERVER__ && itemId) {
                data.cursor = cursor;
                data.pageSize = 4;
                data.wrap = true;
            } else if (global.__SERVER__) {
                data.pageSize = count;
                data.cursor = (page - 1) * count;
            }
            request.send((0, _extends3.default)({ ids: catalogIds }, data));
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postCatalogItems2: function postCatalogItems2(_ref6) {
        var authToken = _ref6.authToken,
            buyNow = _ref6.buyNow,
            catalogIds = _ref6.catalogIds,
            count = _ref6.count,
            deployment = _ref6.deployment,
            cursor = _ref6.cursor,
            itemId = _ref6.itemId,
            page = _ref6.page;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/small/catalog/items2' });
            var data = {};
            if (global.__SERVER__ && itemId) {
                data.cursor = cursor;
                data.pageSize = 4;
                data.wrap = true;
            } else if (global.__SERVER__) {
                data.pageSize = count;
                data.cursor = (page - 1) * count;
            }

            data.buyNow = buyNow;

            request.send((0, _extends3.default)({ ids: catalogIds }, data));
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postRegisterForCatalog: function postRegisterForCatalog(_ref7) {
        var authToken = _ref7.authToken,
            catalogId = _ref7.catalogId,
            deployment = _ref7.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                authToken: authToken,
                deployment: deployment,
                path: '<MAINHOST-API>api/b_reg',
                queryParams: { client_version: '4.3' }
            });
            request.type('form');
            request.send({
                accept_terms: 1,
                cat_id: catalogId
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/catalog.js
// module id = zsa3
// module chunks = 60